import mustache from "mustache";

export abstract class BaseComponent<TElement extends HTMLElement> {
  protected createElement(
    tag: string,
    elementId: string | null,
    cssClassList: string[] | null,
  ): TElement {
    const element: TElement = document.createElement(tag) as TElement;
    if (elementId) {
      element.id = elementId;
    }
    if (cssClassList) {
      cssClassList.forEach((cssClass) => {
        element.classList.add(cssClass);
      });
    }
    return element;
  }

  protected createElementFromTemplate(
    templateString: string,
    data: any,
  ): TElement {
    const template = document.createElement("template");
    template.innerHTML = mustache.render(templateString, data);
    return template.content.children[0] as TElement;
  }

  protected createHtmlString(templateString: string, data: any): string {
    return mustache.render(templateString, data);
  }

  //

  public abstract init(): void;

  public abstract dispose(): void;
}
